import * as React from 'react'
import { CartesianGrid as RechartsCartesianGrid } from 'recharts'

export function CartesianGrid({
  vertical = false,
  ...props
}: React.PropsWithoutRef<React.ComponentProps<typeof RechartsCartesianGrid>>) {
  return (
    <RechartsCartesianGrid
      vertical={vertical}
      stroke={null as any} // Types don’t allow null
      strokeDasharray="3 3"
      className="stroke-gray-100 dark:stroke-gray-700"
      {...props}
    />
  )
}

CartesianGrid.displayName = RechartsCartesianGrid.displayName
